import React, { useState, useEffect, useCallback } from "react";
import { Route, Switch, useHistory } from "react-router-dom";
import { connect } from "react-redux";
import data from "../../assets/apiRoutes.json";
import Button from "devextreme-react/button";
import axios from "axios";
import ScrollView from "devextreme-react/scroll-view";
import { storeDatabaseCompanies } from "../../redux/actions/security";
import RadioGroup, { RadioGroupTypes } from 'devextreme-react/radio-group';
import { confirm } from 'devextreme/ui/dialog';
import AddEditUser from "./AddEditUser";
import ResetPassword from "./ResetPassword";
import { useDispatch } from "react-redux";
import DataGrid, {
    Column,
    Paging,
    FilterRow,
    FilterPanel,
    ColumnChooser,
    ColumnChooserSearch,
    FilterBuilderPopup,
    StateStoring,
    Editing,
    LoadPanel,
    Export,
    Pager,
    HeaderFilter,
    Selection,
    Sorting,
    Toolbar,
    Item,
} from 'devextreme-react/data-grid';
import Popup from "devextreme-react/popup";
import _ from "lodash";

const filterBuilderPopupPosition = {
    of: window,
    at: "top",
    my: "top",
    offset: { y: 10 },
};
const UsersGrid = React.createRef();

// The grid is gone once this screen unmounts, but a request started while it was open still resolves -
// and React has already set the ref to null by then. Every call went straight through the ref, so
// navigating away mid-load threw "Cannot read properties of null (reading 'instance')" from inside the
// promise. Returning null instead lets those late callbacks finish quietly.
const usersGridInstance = () => (UsersGrid.current ? UsersGrid.current.instance() : null);
const Users = (props) => {
    let accessToken = props.oidc.user.access_token;
    const dispatch = useDispatch();
    const [idpUsers, setIdpUsers] = useState([]);
    const [selectedUserData, setSelectedUserData] = useState({ userName: '' });
    const [linkTo, setLinkTo] = useState(null);
    const [openResetPasswordDialog, setResetPasswordDialog] = useState(false);
    const [openRoleDialog, setOpenRoleDialog] = useState(false);
    let [globalRoles, setGlobalRoles] = useState([]);
    let [roleSelected, setRoleSelected] = useState();
    const [databaseInfo, setDatabaseInfo] = useState({
        dbName: "",
        companies: [],
    });
    let history = useHistory();
    useEffect(() => {
        loadIdpUsers();
    }, []);
    const loadIdpUsers = () => {
        const grid = usersGridInstance();
        if (grid) {
            grid.beginCustomLoading("Loading");
        }
        axios
            .get(`${window._env_.REACT_APP_AUTH_URL}/${data.idp.getUsers}`)
            .then((res) => {
                const loadedGrid = usersGridInstance();
                if (loadedGrid) {
                    loadedGrid.endCustomLoading();
                }
                setIdpUsers(res.data);
                getDatabasesCompanies();
                const selectedRowKeys = loadedGrid ? loadedGrid.getSelectedRowKeys() : null;
                if (selectedRowKeys && Array.isArray(selectedRowKeys) && selectedRowKeys.length == 1)
                {
                    var elementPos = res.data.map(function(x) {return x.id; }).indexOf(selectedRowKeys[0]);
                    if(elementPos && elementPos >= 0 && elementPos < res.data.length)
                    {
                        setSelectedUserData(res.data[elementPos]);
                    }
                }
            })
            .catch((err) => {
                const failedGrid = usersGridInstance();
                if (failedGrid) {
                    failedGrid.endCustomLoading();
                }
                console.log(err, "Error in loading users");
            });
    };
    const getDatabasesCompanies = () => {
        axios
            .get(
                `${window._env_.REACT_APP_AUTH_URL}/${data.idp.GetDatabasesCompanies}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`
                    }
                }
            )
            .then((res) => {
                console.log(res, "fetch db with companies");
                setDatabaseInfo({
                    ...databaseInfo,
                    companies: res.data.companies,
                });
                dispatch(storeDatabaseCompanies(res.data.companies));
            })
            .catch((err) => {
                console.log(err, "error while gettng databases");
            });
    };
    const onSelectionChanged = (e) => {
        let user = e?.selectedRowsData?.length == 1 ? e?.selectedRowsData[0] : {};
        setSelectedUserData(user);
    };
    const routeChangeToAdd = () => {
        history.push({ pathname: "/security/user-security/assertUser/:userName" });
    }
    const routeChangeToEdit = () => {
        let path = "/security/user-security/assertUser/" + selectedUserData.userName;
        // userName/user sit on the location itself (not under state) because AddEditUser
        // reads props.location.user directly -- same shape the old <Link to={{...}}> pushed.
        history.push({
            pathname: path,
            userName: selectedUserData?.userName,
            user: selectedUserData,
        });
    }
    const deleteUser = (id) => {
        let result = confirm("<i>Are your sure you want to delete selected record?</i>", "Delete");
        result.then((dialogResult) => {
            if (dialogResult) {
                const deletingGrid = usersGridInstance();
                if (deletingGrid) {
                    deletingGrid.beginCustomLoading("Deleting");
                }
                axios
                    .post(
                        `${window._env_.REACT_APP_AUTH_URL}/${data.idp.deleteUser}?userId=${selectedUserData.id}`
                    )
                    .then((res) => {
                        const deletedGrid = usersGridInstance();
                        if (deletedGrid) {
                            deletedGrid.endCustomLoading();
                        }
                        loadIdpUsers();
                    })
                    .catch((err) => {
                        const failedGrid = usersGridInstance();
                        if (failedGrid) {
                            failedGrid.endCustomLoading();
                        }
                        console.log(err, "error in delete user");
                    });
            }
        });
    };
    const onResetPassword = () => {
        setResetPasswordDialog(true);
    };
    const OpenDialogForUserRole = () => {
        setOpenRoleDialog(true);
        let filteredRoles = [];
        let emptyRoleId = "00000000-0000-0000-0000-000000000000";
        let noRoleStr = "No Role Assigned";
        let hasRoleSelected = false;
        axios
            .get(`${window._env_.REACT_APP_AUTH_URL}/${data.idp.loadRoles}`)
            .then((res) => {
                setGlobalRoles(res.data);
                res.data
                    .filter(r => r.id !== emptyRoleId)
                    .map((role) => {
                        selectedUserData.userRoleIds.forEach(roleId => {
                            if (roleId === role.id
                                && role.id !== emptyRoleId) {
                                role.isSelected = true;
                                hasRoleSelected = true;
                            }
                        });
                        filteredRoles.push(role);
                    });

                let rolesWithEmptyrecord = [];
                if (!hasRoleSelected) {
                    rolesWithEmptyrecord.push({ id: emptyRoleId, name: noRoleStr, isSelected: true });
                } else {
                    if (filteredRoles.findIndex(r => r.id == emptyRoleId) === -1) {
                        rolesWithEmptyrecord.push({ id: emptyRoleId, name: noRoleStr, isSelected: false });
                    }
                }
                var rolesUnion = _.union(rolesWithEmptyrecord, filteredRoles);
                setGlobalRoles(rolesUnion);
                let abc = rolesUnion.find(item => item.isSelected == true);
                setRoleSelected(abc.id);
            })
            .catch((err) => {
                console.log(err, "error in loading Roles");
            });
    };
    const hideInfo = () => {
        setOpenRoleDialog(false);
    };
    const hidePasswordPopup = () => {
        setResetPasswordDialog(false);
    };
    const changeRoleEvent = (e) => {
        if (e.previousValue == undefined)
            return;
        let _role = globalRoles.find(item => item.id == e.value);
        _role.isSelected = true;
        setRoleSelected(e.value);
        addRolesToUserInIdp([_role], selectedUserData.userName);
    };
    const addRolesToUserInIdp = (selectedRole, userName) => {
        var addRolesToUserObject = {
            userName: userName,
            roles: selectedRole,
        };
        axios
            .post(
                `${window._env_.REACT_APP_AUTH_URL}/${data.idp.addUserRoles}`,
                addRolesToUserObject
            )
            .then((resp) => {
                var arr = idpUsers;
                var index = _.findIndex(arr, { id: selectedUserData.id });
                _.remove(selectedUserData.userRoleIds);
                selectedUserData.userRoleIds.push(selectedRole[0].id);
                arr.splice(index, 1, selectedUserData);
                setIdpUsers(arr);
                setOpenRoleDialog(false);
                loadIdpUsers();
            })
            .catch((err) => {
                console.log(err);
                loadIdpUsers();
            });
    };

    return (
        <div style={{ overflowY: 'hidden',marginTop:'10px' }}>
            <Switch>
                <Route
                    path="/security/user-security/assertUser/:userName"
                    component={(props) => (
                        <AddEditUser {...props} loadIdpUsers={loadIdpUsers} />
                    )}
                ></Route>
            </Switch>
            <div >
                <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                    dataSource={idpUsers}
                    className="usersecuritygridstyle"
                    showBorders={true}
                    hoverStateEnabled={true}
                    allowColumnResizing={true}
                    allowColumnReordering={true}
                    rowAlternationEnabled={true}
                    columnAutoWidth={true}
                    ref={UsersGrid}
                    keyExpr={"id"}
                    onSelectionChanged={(e) => onSelectionChanged(e)}
                    showRowLines={true}
                    remoteOperations={true}
                    scrolling={{ mode: "standard" }}
                    showColumnLines={false}>
                    <ColumnChooser
                        enabled={true}
                        title="Choose Column"
                        width={290}
                        height={900}
                        sortOrder="asc"
                    >
                        <ColumnChooserSearch
                            enabled={true}
                            editorOptions={{ placeholder: 'Search column' }} />
                    </ColumnChooser>
                    <Sorting mode="multiple" />
                    <LoadPanel enabled={true} />
                    <FilterRow visible={true} />
                    <FilterPanel visible={true} />
                    <HeaderFilter visible={true} />
                    <FilterBuilderPopup position={filterBuilderPopupPosition} />
                    <Export enabled={true} allowExportSelectedData={true} text="Export" />
                    <Selection mode="single" allowSelectAll={false} />
                    <Paging defaultPageSize={10} />
                    <Pager
                        visible={true}
                        showPageSizeSelector={true}
                        allowedPageSizes={[10, 20, 50, 500, 1000, "all"]}
                        showNavigationButtons={true}
                    />
                    <Editing
                        mode="row"
                        useIcons={true}
                        allowUpdating={false}
                        allowDeleting={false} />
                    <Column dataField="userName" caption="User Name"></Column>
                    <Column dataField="email" caption="Email"></Column>
                    <Column dataField="identityId.value" caption="Identity Id"></Column>
                    <Column dataField="userRoleName" caption="Role"></Column>
                    <Toolbar>
                        <Item location="before">
                            <Button
                                onClick={routeChangeToAdd}
                                text="Add User"
                                type="default"
                                stylingMode="contained"
                            >
                            </Button>
                        </Item>
                        <Item location="before">
                            <Button
                                onClick={routeChangeToEdit}
                                text="Edit"
                                type="default"
                                stylingMode="contained"
                                disabled={!selectedUserData.userName}
                            >
                            </Button>
                        </Item>
                        <Item location="before">
                            <Button
                                onClick={deleteUser}
                                text="Delete"
                                type="default"
                                stylingMode="contained"
                                className="margin-right"
                                disabled={!selectedUserData.userName}
                            >
                            </Button>
                        </Item>
                        <Item location="before">
                            <Button
                                onClick={onResetPassword}
                                text="Reset Password"
                                type="default"
                                stylingMode="contained"
                                className="margin-right"
                                disabled={!selectedUserData.userName}
                            >
                            </Button>
                        </Item>
                        <Item location="before">
                            <Button
                                onClick={OpenDialogForUserRole}
                                text="Assign Role"
                                type="default"
                                stylingMode="contained"
                                className="margin-right"
                                disabled={!selectedUserData.userName}
                            >
                            </Button>
                        </Item>
                        <Item name="exportButton" />
                        <Item name="columnChooserButton" />
                    </Toolbar>
                </DataGrid>
            </div>
            {
                openResetPasswordDialog &&
                <ResetPassword
                    openResetPasswordDialog={openResetPasswordDialog}
                    setResetPasswordDialog={setResetPasswordDialog}
                    userInfo={selectedUserData}
                />
            }
            {
                openRoleDialog &&
                <Popup
                    id="accc"
                    container="#root"
                    visible={openRoleDialog}
                    onHiding={hideInfo}
                    hideOnOutsideClick={true}
                    showCloseButton={true}
                    showTitle={true}
                    dragEnabled={false}
                    title="Select User Role"
                    width="40vw"
                    height="50vh"
                    fullScreen={false}
                >
                    <ScrollView width="100%" height="100%">
                        <RadioGroup
                            items={globalRoles}
                            value={roleSelected}
                            valueExpr="id"
                            displayExpr="name"
                            onValueChanged={changeRoleEvent}
                        />
                    </ScrollView>
                </Popup>
            }
        </div>
    )
};

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(Users);